var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcReportLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.8h16c.11 0 .2.09.2.2v19a.2.2 0 0 1-.2.2H7a.2.2 0 0 1-.2-.2V6c0-.11.09-.2.2-.2zM5 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6zm6.95 3.392 5.969 3.482 2.727-2.728a.5.5 0 0 1 .708.708l-3.273 3.272-6.03-3.517-2.73 2.275a.5.5 0 0 1-.641-.768l3.27-2.724zM9 17.5a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-1 0V18a.5.5 0 0 1 .5-.5zm3.5-2a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0v-6zm2.5 1a.5.5 0 0 1 .5.5v4.5a.5.5 0 0 1-1 0V17a.5.5 0 0 1 .5-.5zm3.5 2.5a.5.5 0 0 0-1 0v2.5a.5.5 0 0 0 1 0V19zm2.5-1.5a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-1 0V18a.5.5 0 0 1 .5-.5z",
    fill: "url(#6f1s403zya)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "6f1s403zya",
    x1: 15,
    y1: 4,
    x2: 15,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87523"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReportLight);
export default __webpack_public_path__ + "static/media/ic-report-light.b627098638c49c0097011c22f395ba2b.svg";
export { ForwardRef as ReactComponent };